import { useState } from "react";

export default function Settings({ user }) {
  const [activeSection, setActiveSection] = useState("profile");
  const [profile, setProfile] = useState({ name: user?.name || "", email: user?.email || "", role: user?.role || "", bio: "Senior analyst at InsightForge. Focused on growth metrics.", phone: "+1 (555) 000-1234", location: "New York, USA", timezone: "EST (UTC-5)" });
  const [saved, setSaved] = useState(false);
  const [notifs, setNotifs] = useState({ emailAlerts: true, pushNotifs: true, weeklyReport: true, monthlyReport: false, securityAlerts: true, productUpdates: false });
  const [appearance, setAppearance] = useState({ theme: "dark", accentColor: "#6EE7B7", fontSize: "medium", compactMode: false, animationsEnabled: true });
  const [security, setSecurity] = useState({ twoFactor: false, sessionTimeout: "30min", loginAlerts: true });
  const [pwForm, setPwForm] = useState({ current: "", newPw: "", confirm: "" });
  const [pwMsg, setPwMsg] = useState("");
  const [apiKeys] = useState([
    { name: "Production API", key: "if_prod_••••••••••••2a8f", created: "Jan 12, 2024", lastUsed: "Today" },
    { name: "Development API", key: "if_dev_••••••••••••9c3d", created: "Mar 05, 2024", lastUsed: "Yesterday" },
  ]);

  const sections = [
    { id: "profile", label: "Profile", icon: "👤" },
    { id: "notifications", label: "Notifications", icon: "🔔" },
    { id: "appearance", label: "Appearance", icon: "🎨" },
    { id: "security", label: "Security", icon: "🔒" },
    { id: "api", label: "API Keys", icon: "⚡" },
    { id: "billing", label: "Billing", icon: "💳" },
  ];

  const handleSave = () => {
    setSaved(true);
    setTimeout(() => setSaved(false), 2500);
  };

  const handlePwChange = (e) => {
    e.preventDefault();
    if (pwForm.newPw !== pwForm.confirm) { setPwMsg("error"); return; }
    setPwMsg("success");
    setPwForm({ current: "", newPw: "", confirm: "" });
    setTimeout(() => setPwMsg(""), 3000);
  };

  return (
    <div>
      <div style={{ marginBottom: 24 }}>
        <h1 style={{ fontSize: 22, fontWeight: 800, color: "#E8EDF5", marginBottom: 4 }}>Settings</h1>
        <p style={{ fontSize: 13, color: "#8892a4" }}>Manage your account preferences</p>
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "220px 1fr", gap: 20 }}>
        {/* Sidebar */}
        <div style={{ background: "rgba(255,255,255,0.02)", border: "1px solid rgba(255,255,255,0.07)", borderRadius: 16, padding: "12px", height: "fit-content", position: "sticky", top: 80 }}>
          {sections.map(s => (
            <button key={s.id} onClick={() => setActiveSection(s.id)}
              style={{ width: "100%", display: "flex", alignItems: "center", gap: 10, padding: "10px 12px", borderRadius: 10, border: activeSection === s.id ? "1px solid rgba(110,231,183,0.2)" : "1px solid transparent", background: activeSection === s.id ? "rgba(110,231,183,0.08)" : "transparent", color: activeSection === s.id ? "#6EE7B7" : "#8892a4", fontSize: 14, fontWeight: activeSection === s.id ? 700 : 500, cursor: "pointer", marginBottom: 3, transition: "all 0.15s", textAlign: "left", fontFamily: "inherit" }}
              onMouseEnter={e => { if (activeSection !== s.id) { e.currentTarget.style.background = "rgba(255,255,255,0.04)"; e.currentTarget.style.color = "#E8EDF5"; } }}
              onMouseLeave={e => { if (activeSection !== s.id) { e.currentTarget.style.background = "transparent"; e.currentTarget.style.color = "#8892a4"; } }}>
              <span>{s.icon}</span> {s.label}
            </button>
          ))}
        </div>

        {/* Content */}
        <div>
          {activeSection === "profile" && (
            <Section title="Profile Settings" sub="Update your personal information">
              <div style={{ display: "flex", alignItems: "center", gap: 20, marginBottom: 28, padding: "20px", background: "rgba(255,255,255,0.02)", border: "1px solid rgba(255,255,255,0.06)", borderRadius: 14 }}>
                <div style={{ width: 72, height: 72, borderRadius: 18, background: "linear-gradient(135deg,#A78BFA,#60A5FA)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 24, fontWeight: 800, color: "white" }}>{user?.avatar || "U"}</div>
                <div>
                  <p style={{ fontSize: 16, fontWeight: 800, color: "#E8EDF5", marginBottom: 4 }}>{profile.name}</p>
                  <p style={{ fontSize: 13, color: "#8892a4", marginBottom: 10 }}>{profile.role} · {profile.email}</p>
                  <button style={{ padding: "6px 14px", background: "rgba(110,231,183,0.08)", border: "1px solid rgba(110,231,183,0.2)", borderRadius: 8, color: "#6EE7B7", fontSize: 13, fontWeight: 600, cursor: "pointer", fontFamily: "inherit" }}>Change Avatar</button>
                </div>
              </div>
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16, marginBottom: 16 }}>
                {[
                  { label: "Full Name", key: "name", type: "text" },
                  { label: "Email Address", key: "email", type: "email" },
                  { label: "Phone Number", key: "phone", type: "text" },
                  { label: "Location", key: "location", type: "text" },
                  { label: "Timezone", key: "timezone", type: "text" },
                  { label: "Role", key: "role", type: "text" },
                ].map(f => (
                  <div key={f.key}>
                    <label style={{ display: "block", fontSize: 12, fontWeight: 600, color: "#8892a4", marginBottom: 7 }}>{f.label}</label>
                    <input type={f.type} value={profile[f.key]} onChange={e => setProfile(p => ({ ...p, [f.key]: e.target.value }))}
                      style={{ width: "100%", background: "rgba(255,255,255,0.04)", border: "1px solid rgba(255,255,255,0.1)", borderRadius: 10, padding: "10px 14px", color: "#E8EDF5", fontSize: 13, outline: "none", fontFamily: "inherit", transition: "border-color 0.2s" }}
                      onFocus={e => e.target.style.borderColor = "rgba(110,231,183,0.4)"}
                      onBlur={e => e.target.style.borderColor = "rgba(255,255,255,0.1)"} />
                  </div>
                ))}
              </div>
              <div style={{ marginBottom: 24 }}>
                <label style={{ display: "block", fontSize: 12, fontWeight: 600, color: "#8892a4", marginBottom: 7 }}>Bio</label>
                <textarea value={profile.bio} onChange={e => setProfile(p => ({ ...p, bio: e.target.value }))} rows={3}
                  style={{ width: "100%", background: "rgba(255,255,255,0.04)", border: "1px solid rgba(255,255,255,0.1)", borderRadius: 10, padding: "10px 14px", color: "#E8EDF5", fontSize: 13, outline: "none", fontFamily: "inherit", resize: "vertical", transition: "border-color 0.2s" }}
                  onFocus={e => e.target.style.borderColor = "rgba(110,231,183,0.4)"}
                  onBlur={e => e.target.style.borderColor = "rgba(255,255,255,0.1)"} />
              </div>
              <div style={{ display: "flex", gap: 10 }}>
                <SaveBtn onClick={handleSave} saved={saved} />
                <button style={{ padding: "11px 20px", borderRadius: 10, background: "rgba(255,255,255,0.04)", border: "1px solid rgba(255,255,255,0.08)", color: "#8892a4", fontSize: 14, fontWeight: 600, cursor: "pointer", fontFamily: "inherit" }}>Discard</button>
              </div>
            </Section>
          )}

          {activeSection === "notifications" && (
            <Section title="Notification Preferences" sub="Control how and when you receive alerts">
              {[
                { key: "emailAlerts", label: "Email Alerts", desc: "Receive important alerts via email" },
                { key: "pushNotifs", label: "Push Notifications", desc: "In-app browser push notifications" },
                { key: "weeklyReport", label: "Weekly Report", desc: "Summary of weekly performance metrics" },
                { key: "monthlyReport", label: "Monthly Report", desc: "Detailed monthly analytics report" },
                { key: "securityAlerts", label: "Security Alerts", desc: "Alerts for suspicious login activity" },
                { key: "productUpdates", label: "Product Updates", desc: "News about new features and updates" },
              ].map(n => (
                <div key={n.key} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "16px 0", borderBottom: "1px solid rgba(255,255,255,0.05)" }}>
                  <div>
                    <p style={{ fontSize: 14, fontWeight: 600, color: "#E8EDF5", marginBottom: 3 }}>{n.label}</p>
                    <p style={{ fontSize: 12, color: "#8892a4" }}>{n.desc}</p>
                  </div>
                  <Toggle value={notifs[n.key]} onChange={v => setNotifs(p => ({ ...p, [n.key]: v }))} />
                </div>
              ))}
            </Section>
          )}

          {activeSection === "appearance" && (
            <Section title="Appearance" sub="Customize how InsightForge looks">
              <div style={{ marginBottom: 24 }}>
                <label style={{ display: "block", fontSize: 13, fontWeight: 600, color: "#C8D0DC", marginBottom: 12 }}>Theme</label>
                <div style={{ display: "flex", gap: 10 }}>
                  {["dark", "light", "system"].map(t => (
                    <button key={t} onClick={() => setAppearance(p => ({ ...p, theme: t }))} style={{ flex: 1, padding: "12px", borderRadius: 10, border: appearance.theme === t ? "2px solid #6EE7B7" : "1px solid rgba(255,255,255,0.08)", background: appearance.theme === t ? "rgba(110,231,183,0.08)" : "rgba(255,255,255,0.03)", color: appearance.theme === t ? "#6EE7B7" : "#8892a4", fontSize: 13, fontWeight: 600, cursor: "pointer", fontFamily: "inherit", textTransform: "capitalize", transition: "all 0.15s" }}>{t}</button>
                  ))}
                </div>
              </div>
              <div style={{ marginBottom: 24 }}>
                <label style={{ display: "block", fontSize: 13, fontWeight: 600, color: "#C8D0DC", marginBottom: 12 }}>Accent Color</label>
                <div style={{ display: "flex", gap: 10 }}>
                  {["#6EE7B7","#60A5FA","#A78BFA","#F472B6","#FBBF24","#F87171"].map(c => (
                    <div key={c} onClick={() => setAppearance(p => ({ ...p, accentColor: c }))} style={{ width: 36, height: 36, borderRadius: 10, background: c, cursor: "pointer", border: appearance.accentColor === c ? "3px solid white" : "3px solid transparent", transition: "all 0.15s", boxShadow: appearance.accentColor === c ? `0 0 12px ${c}60` : "none" }} />
                  ))}
                </div>
              </div>
              {[
                { key: "compactMode", label: "Compact Mode", desc: "Reduce spacing for more content" },
                { key: "animationsEnabled", label: "Animations", desc: "Enable UI micro-interactions" },
              ].map(s => (
                <div key={s.key} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "14px 0", borderBottom: "1px solid rgba(255,255,255,0.05)" }}>
                  <div>
                    <p style={{ fontSize: 14, fontWeight: 600, color: "#E8EDF5", marginBottom: 2 }}>{s.label}</p>
                    <p style={{ fontSize: 12, color: "#8892a4" }}>{s.desc}</p>
                  </div>
                  <Toggle value={appearance[s.key]} onChange={v => setAppearance(p => ({ ...p, [s.key]: v }))} />
                </div>
              ))}
            </Section>
          )}

          {activeSection === "security" && (
            <Section title="Security" sub="Protect your account">
              <div style={{ marginBottom: 28 }}>
                <h3 style={{ fontSize: 14, fontWeight: 700, color: "#E8EDF5", marginBottom: 16 }}>Change Password</h3>
                <form onSubmit={handlePwChange}>
                  {[
                    { label: "Current Password", key: "current" },
                    { label: "New Password", key: "newPw" },
                    { label: "Confirm New Password", key: "confirm" },
                  ].map(f => (
                    <div key={f.key} style={{ marginBottom: 14 }}>
                      <label style={{ display: "block", fontSize: 12, fontWeight: 600, color: "#8892a4", marginBottom: 7 }}>{f.label}</label>
                      <input type="password" value={pwForm[f.key]} onChange={e => setPwForm(p => ({ ...p, [f.key]: e.target.value }))}
                        style={{ width: "100%", maxWidth: 400, background: "rgba(255,255,255,0.04)", border: "1px solid rgba(255,255,255,0.1)", borderRadius: 10, padding: "10px 14px", color: "#E8EDF5", fontSize: 13, outline: "none", fontFamily: "inherit" }}
                        onFocus={e => e.target.style.borderColor = "rgba(110,231,183,0.4)"}
                        onBlur={e => e.target.style.borderColor = "rgba(255,255,255,0.1)"} />
                    </div>
                  ))}
                  {pwMsg === "success" && <p style={{ color: "#6EE7B7", fontSize: 13, marginBottom: 12 }}>✅ Password updated successfully!</p>}
                  {pwMsg === "error" && <p style={{ color: "#F87171", fontSize: 13, marginBottom: 12 }}>❌ Passwords do not match.</p>}
                  <button type="submit" style={{ padding: "10px 20px", background: "linear-gradient(135deg,#6EE7B7,#34D399)", border: "none", borderRadius: 10, color: "#0A0E17", fontSize: 14, fontWeight: 800, cursor: "pointer", fontFamily: "inherit" }}>Update Password</button>
                </form>
              </div>
              <div style={{ borderTop: "1px solid rgba(255,255,255,0.06)", paddingTop: 24 }}>
                <h3 style={{ fontSize: 14, fontWeight: 700, color: "#E8EDF5", marginBottom: 16 }}>Security Options</h3>
                {[
                  { key: "twoFactor", label: "Two-Factor Authentication", desc: "Add extra security with 2FA" },
                  { key: "loginAlerts", label: "Login Alerts", desc: "Notify on new device logins" },
                ].map(s => (
                  <div key={s.key} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "14px 0", borderBottom: "1px solid rgba(255,255,255,0.05)" }}>
                    <div>
                      <p style={{ fontSize: 14, fontWeight: 600, color: "#E8EDF5", marginBottom: 2 }}>{s.label}</p>
                      <p style={{ fontSize: 12, color: "#8892a4" }}>{s.desc}</p>
                    </div>
                    <Toggle value={security[s.key]} onChange={v => setSecurity(p => ({ ...p, [s.key]: v }))} />
                  </div>
                ))}
              </div>
            </Section>
          )}

          {activeSection === "api" && (
            <Section title="API Keys" sub="Manage your API access tokens">
              <div style={{ marginBottom: 20 }}>
                {apiKeys.map((k, i) => (
                  <div key={i} style={{ background: "rgba(255,255,255,0.02)", border: "1px solid rgba(255,255,255,0.07)", borderRadius: 14, padding: "18px 20px", marginBottom: 12, display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 12 }}>
                    <div>
                      <p style={{ fontSize: 14, fontWeight: 700, color: "#E8EDF5", marginBottom: 4 }}>{k.name}</p>
                      <code style={{ fontSize: 13, color: "#8892a4", background: "rgba(255,255,255,0.05)", padding: "3px 10px", borderRadius: 6 }}>{k.key}</code>
                    </div>
                    <div style={{ textAlign: "right" }}>
                      <p style={{ fontSize: 11, color: "#4B5563", marginBottom: 2 }}>Created {k.created}</p>
                      <p style={{ fontSize: 11, color: "#8892a4", marginBottom: 10 }}>Last used: {k.lastUsed}</p>
                      <div style={{ display: "flex", gap: 6 }}>
                        <button style={{ padding: "5px 12px", background: "rgba(96,165,250,0.1)", border: "1px solid rgba(96,165,250,0.2)", borderRadius: 7, color: "#60A5FA", fontSize: 12, fontWeight: 600, cursor: "pointer", fontFamily: "inherit" }}>Copy</button>
                        <button style={{ padding: "5px 12px", background: "rgba(248,113,113,0.08)", border: "1px solid rgba(248,113,113,0.15)", borderRadius: 7, color: "#F87171", fontSize: 12, fontWeight: 600, cursor: "pointer", fontFamily: "inherit" }}>Revoke</button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              <button style={{ display: "flex", alignItems: "center", gap: 8, padding: "10px 18px", background: "rgba(110,231,183,0.08)", border: "1px solid rgba(110,231,183,0.2)", borderRadius: 10, color: "#6EE7B7", fontSize: 14, fontWeight: 700, cursor: "pointer", fontFamily: "inherit" }}>
                + Generate New Key
              </button>
            </Section>
          )}

          {activeSection === "billing" && (
            <Section title="Billing & Plan" sub="Manage your subscription">
              <div style={{ background: "linear-gradient(135deg, rgba(110,231,183,0.08), rgba(96,165,250,0.06))", border: "1px solid rgba(110,231,183,0.2)", borderRadius: 16, padding: "24px", marginBottom: 20 }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
                  <div>
                    <span style={{ fontSize: 12, fontWeight: 700, color: "#6EE7B7", background: "rgba(110,231,183,0.15)", padding: "3px 10px", borderRadius: 20, letterSpacing: "0.08em" }}>PRO PLAN</span>
                    <p style={{ fontSize: 28, fontWeight: 800, color: "#E8EDF5", marginTop: 10, marginBottom: 4 }}>$49 <span style={{ fontSize: 14, fontWeight: 400, color: "#8892a4" }}>/month</span></p>
                    <p style={{ fontSize: 13, color: "#8892a4" }}>Next billing: January 12, 2025</p>
                  </div>
                  <button style={{ padding: "8px 16px", background: "rgba(255,255,255,0.06)", border: "1px solid rgba(255,255,255,0.12)", borderRadius: 9, color: "#E8EDF5", fontSize: 13, fontWeight: 600, cursor: "pointer", fontFamily: "inherit" }}>Manage Plan</button>
                </div>
              </div>
              <h3 style={{ fontSize: 14, fontWeight: 700, color: "#E8EDF5", marginBottom: 14 }}>Plan Features</h3>
              {["Unlimited analytics reports","Up to 50 team members","API access with 100k calls/mo","Priority support","Custom dashboards","Data export (CSV, PDF)"].map((f, i) => (
                <div key={i} style={{ display: "flex", alignItems: "center", gap: 10, padding: "10px 0", borderBottom: "1px solid rgba(255,255,255,0.04)" }}>
                  <span style={{ color: "#6EE7B7", fontSize: 14 }}>✓</span>
                  <span style={{ fontSize: 13, color: "#C8D0DC" }}>{f}</span>
                </div>
              ))}
            </Section>
          )}
        </div>
      </div>
    </div>
  );
}

function Section({ title, sub, children }) {
  return (
    <div style={{ background: "rgba(255,255,255,0.02)", border: "1px solid rgba(255,255,255,0.07)", borderRadius: 16, padding: "28px" }}>
      <h2 style={{ fontSize: 16, fontWeight: 800, color: "#E8EDF5", marginBottom: 4 }}>{title}</h2>
      <p style={{ fontSize: 13, color: "#8892a4", marginBottom: 24 }}>{sub}</p>
      {children}
    </div>
  );
}

function Toggle({ value, onChange }) {
  return (
    <div onClick={() => onChange(!value)} style={{ width: 44, height: 24, borderRadius: 12, background: value ? "#6EE7B7" : "rgba(255,255,255,0.1)", position: "relative", cursor: "pointer", transition: "background 0.25s", flexShrink: 0 }}>
      <div style={{ position: "absolute", top: 3, left: value ? 23 : 3, width: 18, height: 18, borderRadius: "50%", background: value ? "#0A0E17" : "#4B5563", transition: "left 0.25s", boxShadow: "0 2px 4px rgba(0,0,0,0.3)" }} />
    </div>
  );
}

function SaveBtn({ onClick, saved }) {
  return (
    <button onClick={onClick} style={{ padding: "11px 24px", borderRadius: 10, background: saved ? "rgba(110,231,183,0.15)" : "linear-gradient(135deg,#6EE7B7,#34D399)", border: saved ? "1px solid rgba(110,231,183,0.3)" : "none", color: saved ? "#6EE7B7" : "#0A0E17", fontSize: 14, fontWeight: 800, cursor: "pointer", fontFamily: "inherit", transition: "all 0.3s" }}>
      {saved ? "✅ Saved!" : "Save Changes"}
    </button>
  );
}